import classes from './ContactIcon.module.css';

const ContactIcon = (props) => {
    return (
        <li className={classes.ContactIconItem}>
            <a href={props.link} target="_blank" rel="noreferrer">
                <span className={classes.Icon}>{props.icon}</span>
                {props.text}
            </a>
        </li>
    );
}

export default ContactIcon;